/*
 *
 * AudienceDetail actions
 *
 */

import {
  FLUSH_STATE_AUDIENSE,
  INITIAL_ID,
  // load item detail
  LOAD_AUDIENSE,
  LOAD_AUDIENSE_SUCCESS,
  LOAD_AUDIENSE_ERROR,
  // update item
  UPDATE_AUDIENSE,
  UPDATE_AUDIENSE_SUCCESS,
  UPDATE_AUDIENSE_ERROR,
  // delete item
  HARD_DELETE_AUDIENSE,
  HARD_DELETE_AUDIENSE_SUCCESS,
  HARD_DELETE_AUDIENSE_ERROR,
} from "./constants";

/**
 * Clearing the state for AudienceDetail
 */
export function flushState() {
  return {
    type: FLUSH_STATE_AUDIENSE,
  };
}

/**
 * Main ID for detail commponents
 */
export function setInitialID(initialID) {
  return {
    type: INITIAL_ID,
    initialID,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the Audience Detail, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_AUDIENSE
 */
export function loadAudienceDetail(detailID) {
  return {
    type: LOAD_AUDIENSE,
    detailID,
  };
}

/**
 * Dispatched when the loadAudienceDetail are loaded by the request saga
 *
 * @param  {array} variables true for Audience detail
 *
 * @return {array} An action object with a type of LOAD_AUDIENSE_SUCCESS passing the variables
 */
export function loadAudienceDetailSuccess(itemDetail) {
  return {
    type: LOAD_AUDIENSE_SUCCESS,
    itemDetail,
  };
}

/**
 * Dispatched when loading the loadAudienceDetail fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_AUDIENSE_ERROR passing the error
 */
export function loadAudienceDetailError(errorDetail) {
  return {
    type: LOAD_AUDIENSE_ERROR,
    errorDetail,
  };
}

/**
 * ------------------ CHANGE ------------------
 */

/**
 * Change/Update the Audience, this action starts the request saga
 * changeAction: "new" || 'copy'
 *
 * @return {array} An action object with a type of UPDATE_AUDIENSE
 */
export function changeAudience(itemDetail, changeAction = "new") {
  return {
    type: UPDATE_AUDIENSE,
    itemDetail,
    changeAction,
  };
}

/**
 * Dispatched when the changeAudience are changed/updated by the request saga
 *
 * @param  {array} itemDetail true for AUDIENSEs
 *
 * @return {array} An action object with a type of UPDATE_AUDIENSE_SUCCESS passing the variables
 */
export function changeAudienceSuccess(itemDetail) {
  return {
    type: UPDATE_AUDIENSE_SUCCESS,
    itemDetail,
  };
}

/**
 * Dispatched when loading the changeAudience fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of UPDATE_AUDIENSE_ERROR passing the error
 */
export function changeAudienceError(errorUpdate) {
  return {
    type: UPDATE_AUDIENSE_ERROR,
    errorUpdate,
  };
}

/**
 * ------------------ HARD DELETE ------------------
 */

// Hard Delete for Single Item
export function hardDeleteAudience(hardDeleteId) {
  return {
    type: HARD_DELETE_AUDIENSE,
    hardDeleteId,
  };
}
export function hardDeleteAudienceSuccess(hardDeleteDetail, hardDeleteId) {
  return {
    type: HARD_DELETE_AUDIENSE_SUCCESS,
    hardDeleteDetail,
    hardDeleteId,
  };
}

export function hardDeleteAudienceError(hardDeleteError) {
  return {
    type: HARD_DELETE_AUDIENSE_ERROR,
    hardDeleteError,
  };
}
